const map = {
	"./bg.json": 5123,
	"./cs.json": 2610,
	"./da.json": 1695,
	"./de.json": 30259,
	"./el.json": 74389,
	"./en-US.json": 16350,
	"./en.json": 26715,
	"./en_US.json": 9184,
	"./es.json": 30220,
	"./et.json": 1101,
	"./fjordkraft_no.json": 35703,
	"./fr.json": 42272,
	"./hr.json": 56242,
	"./hu.json": 17647,
	"./it.json": 12889,
	"./lt.json": 20520,
	"./nb.json": 99608,
	"./nl.json": 71342,
	"./nn.json": 95388,
	"./no.json": 1455,
	"./pl.json": 57884,
	"./pt.json": 79364,
	"./ro.json": 22379,
	"./sk.json": 81450,
	"./sl.json": 743,
	"./sv.json": 10969,
	"./uk.json": 27620
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 71147;